export enum SearchCategory {
  JobSeeker = 'JobSeeker',
  Company = 'Company',
  JobOffer = 'JobOffer',
}
